// extracted by mini-css-extract-plugin
module.exports = {"banner":"PaymentFailedBanner_banner__G5Ini"};